import { jsPDF } from "jspdf";
// eslint-disable-next-line no-unused-vars
import autoTable from "jspdf-autotable";
import { asArray, isValid } from "../../page/utils";
import config from "../../../config";

const headLabelNcfType = {
	"01": "FACTURA DE CREDITO FISCAL",
	"02": "FACTURA DE CONSUMO",
	"14": "FACTURA DE REGIMEN ESPECIAL",
	"15": "FACTURA GUBERNAMENTAL",
	"def": "FACTURA"
}

/**
 * @param { {
 *   company: string,
 *   code: string,
 *   logoUrl?: string, // URL del logo de la empresa
 *   header: [{
 *     invoicecode: string,
 *     ncf_expiration: string,
 *     ncf: string,
 *     salescode: string,
 *     fecha: string,
 *     status: string,
 *     purpose: string,
 *     custcode: string,
 *     customer_code: string,
 *     name: string,
 *     credit_limit: string,
 *     credit_days: string,
 *     ncf_type: string,
 *     documento: string,
 *     documento_numero: string,
 *     notas: string,
 *     net: string,
 *     itbis: string,
 *     total: string,
 *     invoicedate: string
 *   }],
 *   line: [{
 *     net_amount: string,
 *     itbis_amount: string,
 *     line_amount: string,
 *     product: string,
 *     code: string,
 *     name: string,
 *     itbis: string,
 *     unit: string,
 *     qty: string,
 *     price: string
 *   }],
 *   payment: [{
 *     amount: string,
 *     mode: string
 *   }]
 * } props
 */
function factura(props) {
	const param = props;

	function parseDate(dateString = "") {
		if (!dateString) return undefined;

		return dateString.length <= 10 ? new Date(`${dateString}T00:00:00`) : new Date(dateString)
	}

	function formatDate(dateOrString = "") {
		const date = dateOrString instanceof Date ? dateOrString : parseDate(dateOrString)

		if (!date) return "";

		return date.toLocaleDateString("es-DO");
	}

	function formatNumber(num) {
		return Number(num).toLocaleString("es-DO", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}

	function formatCurrency(num) {
		return `RD$ ${formatNumber(num)}`;
	}

	var doc = new jsPDF({ format: "letter", orientation: "portrait" });
	var docWidth = doc.internal.pageSize.width;
	var marginX = 20;
	var marginY = 20;
	var currentHeight = marginY + 6;
	var docFooter = doc.internal.pageSize.height - marginY;

	var pdfConfig = {
		headerTextSize: 16,
		subHeaderTextSize: 14,
		labelTextSize: 12,
		fieldTextSize: 10,
		smallTextSize: 9,
		lineHeight: 6,
		subLineHeight: 4,
	};

	// Datos de la empresa
	const empresa = isValid(param.companyinfo) ? asArray(param.companyinfo)[0] : {
		nombre: "Papelería Doble K, SRL",
		rnc: "131-48937-2",
		contacto: "papeleriadoblek@gmail.com",
		telefono: "(809) 793-9595",
		direccion: "Calle Wenceslao Álvarez, casi esq. Juan Sánchez Ramírez, Zona Universitaria, Santo Domingo, D.N. Local 101.",
		logo: "F5C3E49E-B940-4D5A-BE60-FDCE470A4AC4"
	};

	// Header de la factura
	const headerData = param.header[0];

	// Logo de la empresa (si existe)
	if (empresa.logo) {
		try {
			doc.addImage(
				`${config.apiUrl}/file/${empresa.logo}`,
				'PNG',
				marginX,
				currentHeight - 8,
				55,
				30,
				undefined,
				'FAST'
			);
		} catch (error) {
			console.warn('Error al cargar el logo:', error);
		}
	}

	let borderRight = docWidth - marginX - 3
	let borderLeft = marginX + 2

	// Título principal - más grande
	doc.setFontSize(pdfConfig.headerTextSize);
	doc.setFont("helvetica", "bold");
	doc.text(headLabelNcfType[headerData.ncf_type] || headLabelNcfType.def, borderRight, currentHeight + 2, { align: "right" });
	currentHeight += 10;

	// Número de factura - más prominente
	if (headerData.ncf) {
		doc.setFontSize(pdfConfig.subHeaderTextSize);
		doc.setFont("helvetica", "bold");
		doc.text(`NCF: ${headerData.ncf}`, borderRight, currentHeight, { align: "right" });
		currentHeight += 5;

		// Fecha y validez
		const fechaVencimiento = formatDate(headerData.ncf_expiration);

		doc.setFontSize(pdfConfig.labelTextSize);
		doc.setFont("helvetica", "normal");
		doc.text(`Válida hasta: ${fechaVencimiento}`, borderRight, currentHeight, { align: "right" });
		currentHeight += 8;
	} else {
		currentHeight += 13;
	}


	// Número de factura - más prominente
	doc.setFontSize(pdfConfig.labelTextSize);
	doc.setFont("helvetica", "bold");
	doc.text(`Factura #: ${headerData.invoicecode}`, borderRight, currentHeight, { align: "right" });


	currentHeight = marginY + 28

	doc.setFontSize(pdfConfig.labelTextSize);
	doc.setFont("helvetica", "normal");
	doc.text(empresa.nombre, borderLeft, currentHeight, { align: "left" });
	currentHeight += 5;

	doc.text(`RNC ${empresa.rnc}`, borderLeft, currentHeight, { align: "left" });
	currentHeight += 5;

	const fechaEmision = formatDate(headerData.invoicedate);


	doc.setFontSize(pdfConfig.fieldTextSize);
	doc.setFont("helvetica", "normal");
	doc.text(`Fecha: ${fechaEmision}`, borderLeft, currentHeight, { align: "left" });
	// Fin header empresa

	currentHeight = marginY + 40;

	doc.setFillColor(242, 219, 219)
	doc.rect(marginX, currentHeight, docWidth - marginX * 2 - 1, 16, "F")
	doc.setFillColor(10)
	doc.rect(marginX, currentHeight, docWidth - marginX * 2 - 1, 16, "S")

	borderLeft += 1
	borderRight -= 1

	// Razón Social
	currentHeight += 6;
	doc.setFont("helvetica", "normal");
	doc.setFontSize(pdfConfig.fieldTextSize);
	doc.text(`Cliente: ${headerData.name}`, borderLeft, currentHeight);

	// RNC Cliente
	currentHeight += 7;
	doc.setFont("helvetica", "bold");
	doc.setFontSize(pdfConfig.fieldTextSize);
	doc.text(`RNC: ${headerData.documento_numero}`, borderLeft, currentHeight);

	currentHeight += 3;

	// Tabla de productos con colores mejorados

	borderLeft -= 1
	borderRight += 1

	const tableColumns = ["PRODUCTO", "CANT.", "PRECIO", "ITBIS", "VALOR"];
	const tableRows = [];
	const discountRate = headerData.net ? 1 - (headerData.discount || 0.0) / (headerData.net) : 1
	// Preparar datos de la tabla
	param.line.forEach(item => {
		const row = [
			item.name,
			`${item.qty} ${item.unit || "und"}`,
			formatCurrency(item.price),
			formatCurrency(item.itbis_amount),
			formatCurrency(item.subtotal)
		];
		tableRows.push(row);
	});

	// Configurar y generar la tabla con colores similares al ejemplo
	doc.autoTable({
		head: [tableColumns],
		body: tableRows,
		startY: currentHeight,
		tableLineWidth: 0.25,
		tableLineColor: 0,
		theme: 'grid',
		headStyles: {
			lineWidth: { bottom: 0.5 },
			lineColor: 0,
			fillColor: [229, 184, 184], // Gris claro similar al ejemplo
			textColor: 10,
			fontStyle: 'bold',
			fontSize: 8,
			halign: 'center',
			valign: 'middle'
		},
		bodyStyles: {
			fontSize: 8,
			cellPadding: 1,
			textColor: [0, 0, 0],
			lineColor: 150,
			lineWith: { bottom: 0.5 }
		},
		columnStyles: {
			0: { cellWidth: 75, halign: 'left' }, // PRODUCTO - más ancho
			1: { cellWidth: 20, halign: 'center' }, // CANTIDAD
			2: { cellWidth: 25, halign: 'right' }, // PRECIO
			3: { cellWidth: 25, halign: 'right' }, // ITBIS
			4: { cellWidth: 30, halign: 'right' }  // VALOR
		},
		//margin: { left: marginX, right: marginX +1 , bottom: marginY + 60, top: marginY + 10  },
		margin: { left: marginX, right: marginX + 1 },
		alternateRowStyles: {
			fillColor: [248, 248, 248] // Filas alternadas muy claras
		}
	});

	// Obtener la posición Y después de la tabla

	let totalsHeight = doc.lastAutoTable.finalY;

	if (doc.lastAutoTable.finalY > docFooter - 60) {
		doc.rect(marginX, marginY, docWidth - marginX * 2 - 1, docFooter - marginY, "S")
		doc.addPage()

		doc.line(marginX, 40, docWidth - marginX - 1, 40)
		totalsHeight = 40;
	}

	currentHeight = totalsHeight;

	// Totales - mejorar el diseño
	const subtotal = formatCurrency(headerData.subtotal);
	const descuento = formatCurrency(headerData.discount);
	const itbisTotal = formatCurrency(headerData.itbis);
	const total = formatCurrency(headerData.total);

	const totalesX = borderRight - 40;

	doc.setFontSize(pdfConfig.labelTextSize);
	doc.setFont("helvetica", "normal");

	// Subtotal
	borderRight -= 1

	currentHeight += 6;
	doc.text(subtotal, borderRight, currentHeight, { align: "right" });

	// Descuento
	currentHeight += 7;
	doc.text(descuento, borderRight, currentHeight, { align: "right" });

	// ITBIS
	currentHeight += 7;
	doc.text(itbisTotal, borderRight, currentHeight, { align: "right" });

	// Total principal - más destacado
	//doc.setFontSize(pdfConfig.subHeaderTextSize);
	doc.setFont("helvetica", "bold");

	currentHeight += 7;
	doc.setFillColor(230, 230, 230);
	doc.rect(totalesX - 22, currentHeight - 5, docWidth - marginX - totalesX + 21, 7, 'F');

	doc.setTextColor(0, 0, 0);
	doc.text(total, borderRight, currentHeight, { align: "right" });


	currentHeight = totalsHeight;

	doc.setFontSize(pdfConfig.fieldTextSize);
	doc.setFont("helvetica", "normal");

	currentHeight += 6;
	doc.text("SUBTOTAL", totalesX, currentHeight, { align: "right" });

	// Descuento
	currentHeight += 7;
	doc.text("DESC.", totalesX, currentHeight, { align: "right" });

	// ITBIS
	currentHeight += 7;
	doc.text("ITBIS", totalesX, currentHeight, { align: "right" });

	// Total principal - más destacado
	//doc.setFontSize(pdfConfig.subHeaderTextSize);
	doc.setFont("helvetica", "bold");

	// Fondo gris para el total

	currentHeight += 7;
	doc.text("TOTAL", totalesX, currentHeight, { align: "right" });


	currentHeight = totalsHeight + 20;

	// Restablecer color de texto
	doc.setTextColor(0, 0, 0);

	// Fecha de pago - más destacada
	let fechaPago;
	if (!headerData.duedate) {
		const invoiceDate = parseDate(headerData.invoicedate);
		fechaPago = formatDate(invoiceDate.setDate(invoiceDate.getDate() + parseInt(headerData.credit_days)))
	} else {
		fechaPago = formatDate(headerData.duedate);
	}
	doc.setFontSize(pdfConfig.smallTextSize);
	doc.setFont("helvetica", "bold");
	doc.text(`REALIZAR SU PAGO ANTES DE: ${fechaPago}`, borderLeft, currentHeight);
	currentHeight += 6;

	// Nota importante
	doc.setFontSize(pdfConfig.smallTextSize);
	doc.setFont("helvetica", "normal");
	const notasGenerales = doc.splitTextToSize("NO ACEPTABLE COMO COMPROBANTE DE PAGO. EXIJA SU RECIBO.", docWidth - marginX * 2 - 75);

	doc.text(notasGenerales, borderLeft, currentHeight);
	currentHeight += pdfConfig.lineHeight * notasGenerales.length;

	if (headerData.notas) {
		const notasCliente = doc.splitTextToSize(headerData.notas, docWidth - marginX * 2 - 75);

		doc.text(notasCliente, borderLeft, currentHeight);
		currentHeight += pdfConfig.lineHeight * notasCliente.length;
	}

	if (currentHeight > docFooter - 30) {
		doc.rect(marginX, marginY, docWidth - marginX * 2 - 1, docFooter - marginY, "S")
		doc.addPage();
	}

	currentHeight = docFooter - 30;

	// Firmas
	doc.setFontSize(pdfConfig.smallTextSize);
	doc.setFont("helvetica", "normal");
	const firmaX1 = marginX;
	const firmaX2 = docWidth - marginX - 60 - 1;

	doc.setTextColor(150);
	doc.text("Entregado:", firmaX1 + 2, currentHeight);

	doc.text("Recibido:", firmaX2 + 2, currentHeight);


	doc.setTextColor(10)
	// Líneas para firmas
	doc.line(firmaX1, currentHeight + 3, firmaX1 + 60, currentHeight + 3);
	doc.line(firmaX2, currentHeight + 3, firmaX2 + 60, currentHeight + 3);

	currentHeight += 15;

	// Información de contacto - con separador
	doc.setFontSize(pdfConfig.fieldTextSize);
	doc.setFont("helvetica", "normal");
	doc.text(`Contacto: ${empresa.contacto} | ${empresa.telefono}`, borderLeft, currentHeight);
	currentHeight += 6;

	// Dirección
	doc.setFontSize(pdfConfig.smallTextSize);
	const direccionLines = doc.splitTextToSize(empresa.direccion, docWidth - marginX * 2 - 5);
	doc.text(direccionLines, borderLeft, currentHeight);
	currentHeight += pdfConfig.lineHeight * direccionLines.length;

	// Código de documento

	doc.setFont("helvetica", "bold");
	doc.setFontSize(pdfConfig.smallTextSize);
	doc.text(param.code, borderRight, docFooter - 2, { align: "right" });

	doc.rect(marginX, marginY, docWidth - marginX * 2 - 1, docFooter - marginY, "S")

	return doc;
}

export default factura;
